import {
  getInventoriesApi,
  getInventoriesOverviewApi,
  deleteInventoryApi,
  downloadInventoryApi,
  uploadInventoryApi,
  deleteInventoriesByFilterApi,
  searchInventoryApi,
} from './inventories.api';
import { ToastUtil } from '../utils/toast.util';

export const getInventoriesReducers = (builder) => {
  builder
    .addCase(getInventoriesApi.pending, (state) => {
      state.getInventoriesStatus = 'pending';
    })
    .addCase(getInventoriesApi.fulfilled, (state, { payload }) => {
      state.getInventoriesStatus = 'fulfilled';
      state.inventories = payload.inventories;
      state.totalInventories = payload.totalCount;
      state.totalPages = payload.totalPages;
      state.currentPage = payload.currentPage;
    })
    .addCase(getInventoriesApi.rejected, (state, action) => {
      state.getInventoriesStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const getInventoriesOverviewReducers = (builder) => {
  builder
    .addCase(getInventoriesOverviewApi.pending, (state) => {
      state.getOverviewStatus = 'pending';
    })
    .addCase(getInventoriesOverviewApi.fulfilled, (state, { payload }) => {
      state.getOverviewStatus = 'fulfilled';
      state.overview = payload;
    })
    .addCase(getInventoriesOverviewApi.rejected, (state, action) => {
      state.getOverviewStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const deleteInventoryReducers = (builder) => {
  builder
    .addCase(deleteInventoryApi.pending, (state) => {
      state.deleteInventoryStatus = 'pending';
    })
    .addCase(deleteInventoryApi.fulfilled, (state, { payload }) => {
      state.deleteInventoryStatus = 'fulfilled';

      if (payload.success) {
        const deletedId = payload.data;
        state.inventories = state.inventories.filter(
          (inventory) => inventory._id !== deletedId,
        );
        state.totalInventories -= 1;
        state.totalPages = Math.ceil(state.totalInventories / 10);
      } else {
        state.error = payload.message;
      }

      ToastUtil.handleApiResponse(payload, 'Delete Successful', 'Delete Failed');
    })
    .addCase(deleteInventoryApi.rejected, (state, action) => {
      state.deleteInventoryStatus = 'failed';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Delete failed',
        action?.error?.message || 'Failed to delete inventory',
      );
    });
};

export const downloadInventoryReducers = (builder) => {
  builder
    .addCase(downloadInventoryApi.pending, (state) => {
      state.downloadInventoryStatus = 'pending';
    })
    .addCase(downloadInventoryApi.fulfilled, (state) => {
      state.downloadInventoryStatus = 'fulfilled';
      ToastUtil.success('Download Successful', 'Your file download has started');
    })
    .addCase(downloadInventoryApi.rejected, (state, action) => {
      state.downloadInventoryStatus = 'failed';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Download failed',
        action?.error?.message || 'Failed to download inventory file',
      );
    });
};

export const uploadInventoryReducers = (builder) => {
  builder
    .addCase(uploadInventoryApi.pending, (state) => {
      state.uploadInventoryStatus = 'pending';
    })
    .addCase(uploadInventoryApi.fulfilled, (state, { payload }) => {
      state.uploadInventoryStatus = 'fulfilled';

      if (!payload.success) {
        state.error = payload.message;
      }

      ToastUtil.handleApiResponse(payload, 'Upload Successful', 'Upload Failed');
    })
    .addCase(uploadInventoryApi.rejected, (state, action) => {
      state.uploadInventoryStatus = 'failed';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Upload failed',
        action?.error?.message || 'Failed to upload inventory file',
      );
    });
};

export const deleteInventoriesByFilterReducers = (builder) => {
  builder
    .addCase(deleteInventoriesByFilterApi.pending, (state) => {
      state.deleteInventoriesByFilterStatus = 'pending';
    })
    .addCase(deleteInventoriesByFilterApi.fulfilled, (state, { payload }) => {
      state.deleteInventoriesByFilterStatus = 'fulfilled';

      if (payload.success) {
        // Reset inventories list to trigger refresh
        state.inventories = [];
        state.totalInventories = 0;
        state.totalPages = 0;
        state.currentPage = 1;
      } else {
        state.error = payload.message;
      }

      ToastUtil.handleApiResponse(
        payload,
        'Bulk Delete Successful',
        'Bulk Delete Failed',
      );
    })
    .addCase(deleteInventoriesByFilterApi.rejected, (state, action) => {
      state.deleteInventoriesByFilterStatus = 'failed';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Bulk delete failed',
        action?.error?.message || 'Failed to delete inventories',
      );
    });
};

export const searchInventoryReducers = (builder) => {
  builder
    .addCase(searchInventoryApi.pending, (state) => {
      state.searchInventoryStatus = 'pending';
    })
    .addCase(searchInventoryApi.fulfilled, (state, { payload }) => {
      state.searchInventoryStatus = 'fulfilled';
      state.searchResults = payload.results;
      state.searchTotalCount = payload.totalCount;
      state.searchTotalPages = payload.totalPages;
      state.searchCurrentPage = payload.currentPage;
    })
    .addCase(searchInventoryApi.rejected, (state, action) => {
      state.searchInventoryStatus = 'failed';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Search failed',
        action?.error?.message || 'Failed to search inventory',
      );
    });
};
